export default "<app-loading></app-loading>";